<template>
    <div>
        <div v-if="editProtocolo && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmit" v-if="!editProtocolo || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editProtocolo || dados.id">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8" v-if="isSMED">
                        <el-form-item label="Instituição / Origem" key="instituicao_id">
                            <div class="style-input readonly">SECRETARIA (SEM INSTITUIÇÃO)</div>
                        </el-form-item>
                    </el-col>

                    <el-col :xs="24" :sm="isSMED ? 16 : 24" :md="isSMED ? 16 : 24">
                        <el-form-item label="Assunto" prop="titulo" :rules="[$requiredBlur]" key="titulo">
                            <el-input v-model="dados.titulo" maxlength="191" v-on:blur="formatUpper('titulo')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item label="Descrição" prop="descricao" key="descricao">
                            <el-input type="textarea" :rows="5" v-model="dados.descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" class="u-mt-10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div v-if="dados.id" class="alert alert-info" style="margin-bottom: 0;">
                            <b>Nº do protocolo:</b> {{ dados.id }}
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
                        <el-button v-if="dados.id" type="primary" @click="print()">IMPRIMIR PROTOCOLO</el-button>
                        <el-button type="primary" id="btn-protocolo" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['paramId'],
    data: () => ({
        editProtocolo: false,
        dados: {
            id: '',
            instituicao_id: null,
            titulo: '',
            descricao: ''
        }
    }),
    computed: {
        isSMED () {
            const t = Number(this.$store.state.user.tipo)
            return [4, 5, 6].includes(t)
        }
    },
    methods: {
        getById (id) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/protocolo/getById/` + id, this.$store.getters.getHeaderAuth)
                .then(response => {
                    this.dados = JSON.parse(JSON.stringify(response.data))
                }).catch((error) => { this.$store.commit('throwException', error) })
        },
        onSubmit () {
            document.getElementById('btn-protocolo').focus()
            this.$refs.dados.validate((valid) => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
                    return
                }

                window.eventBus.$emit('loading', true)
                // SMED sempre registra como Secretaria (sem instituição)
                if (this.isSMED) this.dados.instituicao_id = null
                // Perfis de instituição: fixa a instituição selecionada no sistema
                if (!this.isSMED) {
                    const inst = this.$store.state.config && this.$store.state.config.instituicao ? this.$store.state.config.instituicao : null
                    this.dados.instituicao_id = inst && inst.id ? inst.id : null
                }
                const url = this.editProtocolo
                    ? `${this.$store.state.config.baseUrlApi}/api/protocolo/update/` + this.dados.id
                    : `${this.$store.state.config.baseUrlApi}/api/protocolo/store`

                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
                    .then(response => {
                        window.eventBus.$emit('loading', false)
                        window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                        this.dados = JSON.parse(JSON.stringify(response.data))
                        this.$emit('onSubmitProtocolo')
                    })
                    .catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
            })
        },
        print () {
            if (!this.dados.id) return
            window.eventBus.$emit('print', { url: '/api/pdf/renderProtocolo', param: { id: this.dados.id } })
        },
        formatUpper (field) {
            if (!this.dados[field]) return
            this.dados[field] = this.dados[field].toUpperCase()
            this.dados[field] = this.$removerAcentos(this.dados[field])
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {
                if (value) {
                    this.getById(value)
                    this.editProtocolo = true
                }
            }
        }
    }
}
</script>

